import { render, staticRenderFns } from "./creatBidFile.vue?vue&type=template&id=3be734e4&scoped=true"
import script from "./creatBidFile.vue?vue&type=script&lang=js"
export * from "./creatBidFile.vue?vue&type=script&lang=js"
import style0 from "./creatBidFile.vue?vue&type=style&index=0&id=3be734e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be734e4",
  null
  
)

export default component.exports